__turbopack_context__.v({
  "back-previous": "BackToPreviousView-module-scss-module__GS813q__back-previous",
});
